import axios from 'axios';
import oauth from './oauth';

let isRefreshing = false;
let refreshSubscribers = [];

const api = axios.create({
  baseURL: '', // Ustawiamy później dynamicznie
  headers: {
    'Content-Type': 'application/json',
  },
});

function onRefreshed(token) {
  refreshSubscribers.forEach((callback) => callback(token));
  refreshSubscribers = [];
}

function addRefreshSubscriber(callback) {
  refreshSubscribers.push(callback);
}

function logout() {
  oauth.logout();
  refreshSubscribers = [];
  window.location = '#/login';
  window.location.reload();
}

/**
 * Ustawienie bazy API dynamicznie (bez pluginów)
 */
export const initApi = () => {
  const baseUrl = CONFIG.url.api;
  api.defaults.baseURL = `${baseUrl}/api`;

  // Automatyczne odświeżanie tokenów na 401
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      /* eslint no-underscore-dangle: 0 */
      if (error.response?.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          // Jeśli już trwa odświeżanie, dodaj do kolejki
          return new Promise((resolve) => {
            addRefreshSubscriber((token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              resolve(api(originalRequest));
            });
          });
        }

        // Inicjuj odświeżenie
        originalRequest._retry = true;
        isRefreshing = true;

        const success = await oauth.refreshToken();

        if (success) {
          const newToken = oauth.getAccessToken();
          isRefreshing = false;
          api.defaults.headers.Authorization = `Bearer ${newToken}`;
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          onRefreshed(newToken);
          return api.request(originalRequest); // Ponowna próba żądania
        }
        logout();
      }
      return Promise.reject(error);
    },
  );

  // Ustawienie nagłówka autoryzacji jeśli token istnieje
  const token = oauth.getAccessToken();
  if (token) {
    api.defaults.headers.Authorization = `Bearer ${token}`;
  }
};

export default api;
